/**
 * Service worker registration and install-prompt plumbing.
 *
 * Registration is skipped in development: the CRA dev server serves modules that a
 * cache-first worker would happily pin to a stale build, which turns every code
 * change into a "why is nothing updating" hunt.
 */

const SW_URL = "/service-worker.js";

export const registerServiceWorker = () => {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(SW_URL)
      .then((registration) => {
        // Tell the page when a new build is waiting so it can offer a reload
        // rather than silently serving yesterday's bundle.
        registration.addEventListener("updatefound", () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener("statechange", () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              window.dispatchEvent(new CustomEvent("tz-update-ready", { detail: registration }));
            }
          });
        });
      })
      .catch((e) => console.warn("Service worker registration failed:", e));
  });
};

export const applyWaitingUpdate = (registration) => {
  registration?.waiting?.postMessage("skip-waiting");
  window.location.reload();
};
